<div class="modal-background" bdFxLayoutAlign="center start">

    <div class="filter-modal">
        <div class="container">
            <div class="header">
                <a (click)="closeOnlyAndNotifyClient()" class="cancel">Abbrechen</a>
                <div class="title">Sales Concierge</div>
                <div class="buttons">
                    <button class="reset" (click)="reset()" [disabled]="!resetEnabled">Reset</button>

                </div>
            </div>
            <div class="content"
                 [ngStyle]="showRequestType ? {'background-image': 'url(./assets/images/sales_concierge.png)'} : {'background-image': 'none'}"
                 [ngClass]="{'no-background':!showRequestType}">
                <div class="title" *ngIf="showRequestType">Herzlich willkommen beim Sales Concierge!</div>
                <p class="description" *ngIf="showRequestType">
                    Einige kurze Angaben helfen unserem Sales Concierge, Sie bestmöglich zu unterstützen.<br>
                    Ob Produktberatung oder technischer Support - anhand weniger Daten kann unser Concierge Ihr Thema
                    vor
                    der Kontaktaufnahme vorbereiten,
                    oder bei Bedarf die passende Brother-Fachabteilung einschalten.

                </p>
                <div class="divider" *ngIf="showRequestType"></div>

                <sales-concierge-request-type *ngIf="showRequestType"
                                              [reset]="!resetEnabled"
                                              (salesConciergeNextStep)="setRequestNextStep($event)"
                                              [salesConciergeRequest]="salesConciergeRequest"
                                              (selectedSalesConciergeRequest)="setRequestSteps($event)">
                </sales-concierge-request-type>

                <sales-concierge-product-count-info *ngIf="showProductCountInfo"
                                                    (salesConciergeNextStep)="setRequestNextStep($event)"
                                                    [salesConciergeRequest]="salesConciergeRequest"
                                                    [reset]="!resetEnabled"
                                                    (salesConciergeStep)="onPreviousClick($event)"
                                                    (selectedSalesConciergeRequest)="setRequestSteps($event)">
                </sales-concierge-product-count-info>

                <sales-concierge-customer-info *ngIf="showCustomerInfo"
                                               (salesConciergeNextStep)="setRequestNextStep($event)"
                                               [salesConciergeRequest]="salesConciergeRequest" [reset]="!resetEnabled"
                                               (salesConciergeStep)="onPreviousClick($event)"
                                               (selectedSalesConciergeRequest)="setRequestSteps($event)">
                </sales-concierge-customer-info>

                <sales-concierge-customer-contact-info *ngIf="showCustomerContactInfo"
                                                       (salesConciergeNextStep)="setRequestNextStep($event)"
                                                       [salesConciergeRequest]="salesConciergeRequest"
                                                       [reset]="!resetEnabled"
                                                       (salesConciergeStep)="onPreviousClick($event)"
                                                       (selectedSalesConciergeRequest)="setRequestSteps($event)">

                </sales-concierge-customer-contact-info>


            </div>
            <div class="footer">
                <button class="bd-blue-button" [disabled]="!isValid"
                        (click)="onSubmit()"> {{ showCustomerContactInfo ? 'Auf Antwort warten' : 'Weiter' }}
                </button>
            </div>
        </div>
    </div>
</div>
